<template>
  <div>
    <div v-if="issues" class="w-full flex flex-wrap">
      <div class="w-full md:w-1/3 md:pr-4 mb-6">
        <label for="issue" class="block text-sm mb-2">Select Issue: <span class="text-print-order-teal">*</span></label>
        <select v-model="orderItem.issue_id" id="issue" name="issue" class="w-full border px-2 py-3" tabindex="1">
          <option :value="null">Select issue...</option>
          <option v-for="(issue, i) in issues" :key="i" :value="issue.id">{{ issue.name }}</option>
        </select>
        <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('issue_id')" v-text="errorBag.get('issue_id')"></small>
      </div>
      <div class="w-full md:w-1/2 md:pr-4 mb-6" v-if="orderItem.properties.length > 0">
        <div class="w-full mb-4 md:w-1/2 md:pr-2">
            <label for="department" class="block text-sm mb-2">Department: *</label>
            <select v-model="orderItem.department" class="w-full border px-2 py-3">
              <option value="Sales">Sales</option>
              <option value="Lettings">Lettings</option>
            </select>
          </div>
      </div>
    </div>
    <div v-for="(property, i) in orderItem.properties" :key="property.id" class="-mx-4 pb-8">
      <print-order-property :property="property" :propertyNumber="i" :propertySpec="propertySpec" :propertyFields="propertyFields" :propertyEnums="propertyEnums"
        :orderItem="orderItem" :officeId="officeId" :errorBag="errorBag" />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import PrintOrderProperty from './PrintOrderProperty.vue'

export default {
  components: {
    PrintOrderProperty
  },
  props: ['orderItem', 'propertySpec', 'propertyFields', 'issues', 'officeId', 'errorBag'],
  computed: {
    ...mapState(['propertyEnums'])
  },
  created () {
    this.fetchPropertyEnums()
  },
  methods: {
    ...mapActions([
      'fetchPropertyEnums'
    ])
  }
}
</script>
<style lang="scss" scoped>
  #cpo-dropzone table td {
    word-break: break-all;
  }
</style>
